import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatDividerModule } from '@angular/material/divider';
import { MatMenuModule } from '@angular/material/menu';
import { Router, RouterModule } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

import { LoginService } from 'src/app/services/login.service';
import { TranslationService } from 'src/app/services/translation.service';
import { LanguageService } from 'src/app/services/language.service';
import { faChevronDown, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { faUser } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { MatDialog } from '@angular/material/dialog';
import { LanguageSelectorComponent } from '../language-selector/language-selector.component';

@Component({
    selector: 'app-topnav',
    templateUrl: './topnav.component.html',
    styleUrls: ['./topnav.component.scss'],
    imports: [
        BrowserModule,
        RouterModule,
        MatToolbarModule,
        MatButtonModule,
        MatIconModule,
        MatDividerModule,
        MatMenuModule,
        MatFormFieldModule,
        MatSelectModule,
        FontAwesomeModule
    ]
})
export class TopnavComponent implements OnInit {

  @Input() llttfPage = false;

  token: string = '';
  
  contentClass: string = 'collapse navbar-collapse';
  isClicked = true;
  dashboardLink = '';
  count = 0;
  translation: any;
  hideSignInButton:boolean=false
  username:string=""
  signInText:string='Sign In'
  videosText:string='Videos'
  signOutText:string='Sign Out'
  contactUsText:string='Contact Us'
  languageText:string='Language'
  hideNavigationmenu:boolean = true

  constructor (
    private route: Router,
    private _authservice: AuthService,
    private router: Router,
    private _loginservice: LoginService,
    private translationService: TranslationService,
    private languageservice: LanguageService,
    private dialog: MatDialog
  ) { }



  async ngOnInit(): Promise<void> {
    if(this._authservice.getUserLoginData().token != null)
    {
      this.hideSignInButton = true
      this.username = this._authservice.getUserLoginData().username
    }

    this.translationService.getTranslation().subscribe({
      next: (translation) => {
        this.translation = translation
        this.signInText = translation['signinText']
        this.videosText = translation['videosText'] 
        this.signOutText = translation['signoutText']
        this.contactUsText = translation['contactusText']
        this.languageText = translation['languageText']
        
      }
    })
    
  }

  navigate(url: string) {
    this.route.navigateByUrl(url);
  }

  logout(): void {
    this._loginservice.logoutUser().subscribe({
      next: () => {
        window.location.href = '/login';
      }
    });
  }

  toggleMenu() {
    let x = document.getElementById("menuLinks")! as HTMLDivElement;
    
    let hamburger = document.getElementById("hamburger")! as HTMLAnchorElement;

    if (this.count == 0) {
      //x.style.display = "none";
      hamburger.setAttribute('style', 'display:none');
      x.style.marginLeft = "0%";
      x.style.zIndex = '9999';
      this.hideNavigationmenu=false
      this.count = this.count + 1;
    } else {
      //x.style.display = "block";
      hamburger.setAttribute('style', 'display:');
      x.style.marginLeft = "-200%";
      x.style.zIndex = '0';
      this.hideNavigationmenu=true
      this.count = 0;
    }
  }

  openLanguageModal() {
    this.toggleMenu();
    const dialogRef = this.dialog.open(LanguageSelectorComponent, {
      width: '800px'
    });

    dialogRef.afterClosed().subscribe(result => {
      location.reload();
      if (result != null) {
        
          }
        })
      }

 setLanguage(langid: number){
  this.languageservice.setCurrentLang(langid.toString())
 }

  get logoHomePath(): string {
    return this.hideSignInButton ? '/video-store-dashboard' : '/login';
  }

}

